import React from "react";

import { ResponseType, OptionsType } from "commons/types/http";

import useHttpManaged from "hooks/useHttpManaged";

import { PathParamsWithId } from "commons/types/api/common";

import { SectionFourTextsBody, SectionFourTextsDetails } from "types/api/blocks/sectionFourTexts";

function useSectionFourTextsApi() {
    const { get, del, post } = useHttpManaged();
    const getOneSectionFourTexts = React.useCallback((pathParams: PathParamsWithId, options?: OptionsType, headers?: { [x: string]: string }): ResponseType<SectionFourTextsDetails> => {
        return get<PathParamsWithId, undefined, SectionFourTextsDetails>({
            url: "/blocks/section-four-texts/:id",
            pathParams: pathParams,
            options: options,
            headers: headers
        });
    }, [get]);
    const saveSectionFourTexts = React.useCallback((body: SectionFourTextsBody, options?: OptionsType, headers?: { [x: string]: string }): ResponseType<null> => {
        return post<undefined, undefined, SectionFourTextsBody, null>({
            url: "/blocks/section-four-texts",
            body: body,
            options: options,
            headers: headers
        });
    }, [post]);
    const deleteSectionFourTexts = React.useCallback((pathParams: PathParamsWithId, options?: OptionsType, headers?: { [x: string]: string }): ResponseType<null> => {
        return del<PathParamsWithId, undefined, null>({
            url: "/blocks/section-four-texts/:id",
            pathParams: pathParams,
            options: options,
            headers: headers
        });
    }, [del]);
    return {
        getOneSectionFourTexts,
        saveSectionFourTexts,
        deleteSectionFourTexts
    };
}

export default useSectionFourTextsApi;